export default __webpack_public_path__ + "2c35ad0350601d5da1fb53ebef4bf2d8.png";